import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
const SampleLibrary = props => {

    return (
        <div className="col-md-12 text-center">
            <div class="col-md-12 d-flex justify-content-center">
                <div className="col-md-3 p-2" style={{ zIndex: "1000" }}>
                    <label>Customer department</label>
                    <App
                        customerInfo={props.customerWithDepartment}
                        selectedCustomers={props.storeCustomerData}
                    />
                </div>

                <div className="col-md-4 text-left" >
                    <label>For</label>
                    <div className="d-flex">
                        <Field
                            inputType="select"
                            inputName="styleType"
                            value={props.styleType}
                            // options={props.sampleTypeOptions}
                            options={[{ "label": "Style Name", "value": "styleName" }, { "label": "Style No", "value": "styleNo" }]}
                            onChange={props.updateState}
                            disabled={false}
                            className="Select-control"
                        />
                        <input
                            type="text"
                            name="styleTypeValue"
                            title={props.styleTypeValue}
                            className={`form-control w-100 ml-3`}
                            value={props.styleTypeValue}
                            onChange={(e) => props.updateState("styleTypeValue", e.target.value)}
                            onKeyPress={(e) => e.key === "Enter" && props.exportReport()}
                        />
                    </div>
                </div>
                <div className="col-md-2" style={{ zIndex: "1000" }}>
                    <label>Garment Type</label>
                    <Field
                        inputType="select"
                        inputName="garmentType"
                        value={props.garmentType}
                        options={props.garmentTypeOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>


            </div>
            <div className="col-md-12 d-flex justify-content-center">
                <div className="col-md-2">
                    <label>Image Type</label>
                    <Field
                        inputType="select"
                        inputName="imageType"
                        value={props.imageType}
                        options={props.imageTypeOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2">
                    <label>Item No.</label>
                    <input
                        type="text"
                        name="itemNo"
                        title={props.itemNo}
                        className={`form-control w-100`}
                        value={props.itemNo}
                        onChange={(e) => props.updateState("itemNo", e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && props.exportReport()}
                    />
                </div>
                <div className="col-md-2" style={{ zIndex: "1000" }}>
                    <label>Customer Ref No.</label>
                    <input
                        type="text"
                        name="customerRefNo"
                        title={props.customerRefNo}
                        className={`form-control w-100`}
                        value={props.customerRefNo}
                        onChange={(e) => props.updateState("customerRefNo", e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && props.exportReport()}
                    />
                </div>
                <div className="col-md-2" style={{ zIndex: "1000" }}>
                    <label>Actioned By</label>
                    <Field
                        inputType="select"
                        inputName="actionedBy"
                        value={props.actionedBy}
                        options={props.actionedByOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
            </div>
        </div>
    );
};

export default SampleLibrary;


// WEBPACK FOOTER //
// ./src/components/Report/forms/SampleLibrary.js